/*eslint new-cap:0 */
import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import ViewModel from '@bingads-webui-campaign-legacy/adgroup-create-advanced/viewmodel/bid';
import template from '@bingads-webui-campaign-legacy/adgroup-create-advanced/template/steps/bid.pug';
import SearchBidView from '@bingads-webui-campaign-legacy/adgroup-create-advanced/view/steps/search-bid';
import { mediumEnum } from '@bingads-webui-campaign-react/constants';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default class View extends Backbone.View {
  initialize({
    showTrafficEstimation = false,
    budget = 0,
    getKeywordsCb = () => {
      return [];
    },
    adgroup = undefined,
    languages = [],
    campaign = undefined,
    bidStatusEnabled = false,
    isInKeywordCreationWorkflow = false,
    inputLabel = i18n.get('Bids_SearchNetworkBid_New'),
    isForVNext = false,
    activityLogger,
    AdGroupLogId,
    defaultBidValue = null,
  }) {
    this.searchBidView = new SearchBidView({
      adgroup,
      getKeywordsCb,
      budget,
      showTrafficEstimation,
      languages,
      bidStatusEnabled,
      isInKeywordCreationWorkflow,
      inputLabel,
      isForVNext,
      campaign,
      newI18n: this.options.newI18n,
      activityLogger,
      AdGroupLogId,
      defaultBidValue,
    });

    this.viewModel = new ViewModel();
    this.setCampaignAutoBiddingBoolean(campaign);
    this.searchBidView.on('bid:clicked-bid-landscape', (e) => {
      this.trigger('bid:clicked-bid-landscape', e);
    });

    return this;
  }

  render() {
    this.$el.append(template());
    ko.applyBindings(this.viewModel, this.el);
    this.$('.search-bid__container').append(this.searchBidView.render().el);

    return this;
  }

  get bid() {
    return this.searchBidView.viewModel.SearchBid;
  }

  get suggestedBid() {
    return this.searchBidView.viewModel.suggestedBid();
  }

  get isNKW() {
    return this.searchBidView.isNKW;
  }

  get viewedSuggestion() {
    return this.searchBidView.viewedSuggestion;
  }

  get bidStatusEnabled() {
    return this.searchBidView.bidStatusEnabled;
  }

  bidEditable() {
    return !(
      this.searchBidView.viewModel.disableSearchBid() ||
      this.searchBidView.viewModel.isAutoBidding()
    );
  }

  validate() {
    return this.searchBidView.validate();
  }

  getValues() {
    return _.defaults({}, this.searchBidView.getValues());
  }

  resetSearchBidStatus(enable) {
    this.searchBidView.viewModel.disableSearchBid(!enable);
  }

  resetIsAutoBidding(type) {
    this.searchBidView.viewModel.isAutoBidding(this.isCampaignAutoBidding && !_.isEmpty(type) && type === 'InheritFromParent');
  }

  setCampaignAutoBiddingBoolean(campaign) {
    this.isCampaignAutoBidding =
      campaign &&
      campaign.BiddingScheme &&
      campaign.BiddingScheme.Type &&
      _.contains(['MaxClicks', 'MaxConversions', 'TargetCpa', 'TargetRoas', 'MaxConversionValue', 'TargetImpressionShare', 'CostPerSale'], campaign.BiddingScheme.Type);
  }

  updateBidLandscapeAvailability(bidLandscapeAvailable) {
    this.searchBidView.updateBidLandscapeAvailability(bidLandscapeAvailable);
  }

  updateAdGroupMedium(adGroup) {
    this.searchBidView.viewModel.updateAdGroupMedium(adGroup);
  }

  setModel(adgroup) {
    if (adgroup.Medium !== mediumEnum.Content) {
      // have to force the model refresh
      // if you entered a invalid string to bid, like: 'fdas5', the change in view will not change the model
      // and then change to another adgroup with the same bid as the previous valid bid input
      // the model will not refresh view because it thinks it does not change
      this.searchBidView.viewModel.setModel({ SearchBid: 0 });
      //search or search & content
      this.searchBidView.viewModel.setModel(adgroup);
      if (adgroup && adgroup.BiddingScheme) {
        this.resetIsAutoBidding(adgroup.BiddingScheme.Type);
      }
    }
  }
}
